class App {
  basePath = undefined;
  baseUrl = undefined;
  isOfflineMode = false;
  photoInstructionsShown = false;
  cancelMutations = false;
  error = {};

  constructor(parent) {
    this.parent = parent;
  }

  onImageUpload(image, symptoms = []) {
    this.parent.onImageUpload(image, symptoms);
  }

  onFirstGate(result) {
    this.parent.onFirstGate(result);
  }

  onBodyLocationSet() {
    this.parent.onBodyLocationSet();
  }

  onViewAnyway() {
    this.parent.onViewAnyway();
  }

  reset(goHome = true) {
    this.parent.reset(goHome);
  }
}

export default App;
